import React, { useContext, useEffect } from "react";
import { Button } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import question_icon from "../../../../assets/images/question.png";
import axios from "axios";

const AdminDeletePagamento = (props) => {

  const styles = `

  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    display: flex;
    align-items: flex-start;
    align-items: center; 
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;    
  }
  .Editar_container {
    display: flex;
    align-items: flex-start;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
.Editar_Icon {
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
  filter: grayscale(1) invert(1);
}
.Editar_Content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 500px;
  padding: 20px;
  margin: auto;
}
  .Editar_Text {
    color: yellow; 
    font-size: 20px;
    margin-bottom: 20px;
  }
  .Editar_Btns {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  .Botao-Cancelar,
  .Editar_Delete_Btn {
    display: flex;
    justify-content: center; 
    align-items: center; 
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 18px;
    border: none;
    transition: all 0.3s ease;
    width: auto; 
  }
  .Botao-Cancelar {
    background-color: red; 
    color: white;
  }
  .Botao-Cancelar:hover {
    background-color: darkred;
  }
  .Editar_Delete_Btn {
    background-color: green; 
    color: white;
  }
  .Editar_Delete_Btn:hover {
    background-color: darkgreen;
  }
    `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const location = useLocation();
  let navigate = useNavigate();

  const { clienteInfo } = location.state;

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const deleteHandler = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_SERVIDOR}/maquina`,
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: { id },
    };

    axios
      .request(config)
      .then((res) => {
        setNotiMessage({
          type: "success",
          message: "Deleted Successfully.",
        });
        navigate(`/cliente-maquinas/${clienteInfo.id}`, {
          state: location.state.clienteInfo,
        });
      })
      .catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message: "Delete Failed",
          });
          setDataUser(null);
        }
      });
  };

  return (
    <div className="Maquinas-page">

      <div className="Editar_Content">
        <img
          className="Editar_Icon"
          src={question_icon}
          alt="question icon"
        />
        <p className="Editar_Text">
          Deseja excluir essa máquina?
        </p>
        <div className="Editar_Btns">
          <Button
            className="Botao-Cancelar"
            onClick={() => {
              navigate(`/cliente-maquinas/edit-pagamento-adm/${id}`, {
                state: location.state,
              });
            }}
          >
            <span>NÃO</span>
          </Button>{" "}
          <Button
            className="Editar_Delete_Btn"
            onClick={() => {
              deleteHandler();
            }}
          >
            <span>SIM, EXCLUA</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminDeletePagamento;
